<nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-primary">
  <div class="container-fluid">
    <a *ngIf="!settings.tenantName.includes('Eurogeographics')" class="navbar-brand" routerLink="/">
      {{ settings.tenantName }}
    </a>
    <a *ngIf="settings.tenantName.includes('Eurogeographics')" class="navbar-brand" routerLink="/">
      <img height="50" src="../../../assets/els/images/eurogeo-logo.svg" alt="Logo" />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      (click)="isMobileNavbar = !isMobileNavbar"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      [ngClass]="{ collapse: !isMobileNavbar }"
      class="navbar-collapse"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav me-auto">
        <li
          class="nav-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isMobileNavbar = false"
        >
          <a class="nav-link" routerLink="/">Home</a>
        </li>
        <li
          class="nav-item"
          routerLinkActive="active"
          *ngIf="settings.tenantName.includes('Eurogeographics')"
          (click)="isMobileNavbar = false"
        >
          <a class="nav-link" routerLink="/about">About</a>
        </li>
        <li
          class="nav-item"
          routerLinkActive="active"
          *ngIf="settings.tenantName.includes('Eurogeographics')"
          (click)="isMobileNavbar = false"
        >
          <a class="nav-link" routerLink="/contact">Contact</a>
        </li>
      </ul>
      <div class="navbar-text me-3" *ngIf="user">
        <div ngbDropdown>
          <div id="dropdownUser" ngbDropdownToggle>
            <span>Hi</span>, {{ user.firstName }}
            <span class="caret"></span>
          </div>
          <div
            ngbDropdownMenu
            aria-labelledby="dropdownUser"
            class="dropdown-menu-right"
            [ngClass]="{ 'dropdown-offset-mobile': isMobileNavbar }"
          >
            <button class="dropdown-item" routerLink="/account">Your account</button>
            <button
              class="dropdown-item"
              routerLink="/admin"
              *ngIf="user.role === 'TW_ADMIN' || user.role === 'CUSTOMER_ADMIN'"
            >
              Admin
            </button>
            <button class="dropdown-item" (click)="logout()">Logout</button>
          </div>
        </div>
      </div>
      <div class="my-2 my-lg-0">
        <div *ngIf="!user">
          <button class="btn btn-secondary my-2 my-sm-0" type="submit" routerLink="/login">
            Login
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>
<div class="mc-content">
  <router-outlet></router-outlet>
</div>
